<div class="footer">
    <div>
        <span class="company-name">VANDER RISK CONTROL. Todos los derechos reservados.</span><br>
        <!-- <span class="slogan">YOUR SAFETY BASED ON APPLIED SCIENCE.</span> -->
    </div>
    <!-- <div>
        <span>Todos los derechos reservados. <br>
            Versión VRCM-001-2025-OWP.</span>
    </div> -->
</div>